<template>
  <m-div class="text-center">
    <m-div class="">
      <slot name="p1"></slot>
    </m-div>
    <m-div class="">
      <slot name="p2"></slot>

      <slot name="p3"></slot>

      <slot name="p4"></slot>
    </m-div>
  </m-div>
</template>
<script>

export default {}
</script>
